import React from 'react';
import { Button, Card } from 'react-bootstrap';

import ModalWrapper from '../ModalWrapper';

type Props = {
  isShow: boolean;
  title: string;
  closeModal: () => void;
  acceptHandler: any;
  className?: string;
  closeHandler?: () => void;
};

const YesNoModal: React.FC<Props> = ({ isShow, title, closeModal, acceptHandler, closeHandler, className = '' }) => (
  <ModalWrapper className={className} show={isShow} onHide={closeHandler ? () => closeHandler() : closeModal}>
    <Card.Body className="pt-0 pb-2">
      <h6 className="text-center mb-5">{title}?</h6>
      <div className="d-flex justify-content-around">
        <Button className="mr-4 px-5" onClick={closeModal} variant="outline-secondary">
          Ні
        </Button>
        <Button className="px-5" onClick={acceptHandler} variant="outline-danger">
          Так
        </Button>
      </div>
    </Card.Body>
  </ModalWrapper>
);

export default YesNoModal;
